import { render } from "./FeatherEdit3Svg.vue?vue&type=template&id=172d66bc"
const script = {}
script.render = render

export default script